let ptags = []
if (window.hasOwnProperty('product')) {
  ptags = product.tags
}

// TODO: MAKE RULE OPTIONS CMSABLE TO PREVENT DEV REQUIREMENT. AGREED UPON AS TICKET DURING DOWNTIME
// this variable depends on the product variable in product.liquid for "charMax" and "limitHint"
const EMBRULES = {
  'Perry': {
    'charLimitRules': '1-3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Last Initial, Middle Initial',
    'limitHint': '1-3 letters',
    'spaces': false,
    'defaultText': 'wze',
    'allCaps': true,
    'specialChars': false,
  },
  'Ardsley': {
    'charLimitRules': '1,3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Last Initial, Middle Initial',
    'limitHint': '1 or 3 letters',
    'spaces': false,
    'defaultText': 'wze',
    'allCaps': true,
    'specialChars': false,
  },
  'Hudson': {
    'charLimitRules': '1-3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Last Initial, Middle Initial',
    'limitHint': '1-3 letters',
    'spaces': false,
    'defaultText': 'wze',
    'allCaps': true,
    'specialChars': false,
  },
  'Prince': {
    'charLimitRules': '1-4',
    'charMax': ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 4,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:3') ? 3 : 4} letters`,
    'spaces': false,
    'defaultText': 'wze',
    'allCaps': true,
    'specialChars': false,
  },
  'Crosby': {
    'charLimitRules': '3',
    'charMax': 3,
    'charMin': 3,
    'hint': 'e.g. First Initial, Last Initial, Middle Initial',
    'limitHint': '3 letters',
    'spaces': false,
    'defaultText': 'wze',
    'allCaps': true,
    'specialChars': false,
  },
  'Mercer': {
    'charLimitRules': '1',
    'charMax': 1,
    'charMin': 1,
    'hint': 'e.g. First Initial or Last Initial',
    'limitHint': '1 letter',
    'spaces': false,
    'defaultText': 'w',
    'allCaps': true,
    'specialChars': false,
  },
  'River': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:20') ? 20 : ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:20') ? 20 : ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'W',
    'allCaps': false,
    'specialChars': true,
  },
  'Waverly': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'W',
    'allCaps': false,
    'specialChars': true,
  },
  'Mallard': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'Weezie',
    'allCaps': false,
    'specialChars': true,
  },
  'Leeward': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'Weezie',
    'allCaps': false,
    'specialChars': true,
  },
  'Lucy': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'Weezie',
    'allCaps': false,
    'specialChars': true,
  },
  'Tybee': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'W',
    'allCaps': false,
    'specialChars': true,
  },
  'Sullivan': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'W',
    'allCaps': false,
    'specialChars': true,
  },
  'Wave': {
    'charLimitRules': '1-3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-3 letters`,
    'spaces': false,
    'defaultText': 'WZE',
    'allCaps': true,
    'specialChars': false,
  },
  'Angler': {
    'charLimitRules': '1-11',
    'charMax': ptags.includes('embmaxchar:20') ? 20 : ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : 11,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-${ptags.includes('embmaxchar:20') ? 20 : ptags.includes('embmaxchar:10') ? 10 : ptags.includes('embmaxchar:3') ? 3 : ptags.includes('emb:slipper') ? 3 : 11} characters`,
    'spaces': true,
    'defaultText': 'W',
    'allCaps': false,
    'specialChars': true,
  },
  'Deuce': {
    'charLimitRules': '1-3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-3 letters`,
    'spaces': false,
    'defaultText': 'WZE',
    'allCaps': true,
    'specialChars': false,
  },
  'Dink': {
    'charLimitRules': '1-3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-3 letters`,
    'spaces': false,
    'defaultText': 'WZE',
    'allCaps': true,
    'specialChars': false,
  },
  'Birdie': {
    'charLimitRules': '1-3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Middle Initial, Last Initial',
    'limitHint': `1-3 letters`,
    'spaces': false,
    'defaultText': 'WZE',
    'allCaps': true,
    'specialChars': false,
  },
  'Evergreen': {
    'charLimitRules': '1',
    'charMax': 1,
    'charMin': 1,
    'hint': 'e.g. First Initial or Last Initial',
    'limitHint': '1 letter',
    'spaces': false,
    'defaultText': 'w',
    'allCaps': true,
    'specialChars': false,
  },
  'Susan': {
    'charLimitRules': '1',
    'charMax': 1,
    'charMin': 1,
    'hint': 'e.g. First Initial or Last Initial',
    'limitHint': '1 letter',
    'spaces': false,
    'defaultText': 'w',
    'allCaps': true,
    'specialChars': false,
  },
  'Jones': {
    'charLimitRules': '3',
    'charMax': 3,
    'charMin': 3,
    'hint': 'e.g. First Initial, Last Initial, Middle Initial',
    'limitHint': '3 letters',
    'spaces': false,
    'defaultText': 'wze',
    'allCaps': true,
    'specialChars': false,
  },
  'Forsyth': {
    'charLimitRules': '1-3',
    'charMax': 3,
    'charMin': 1,
    'hint': 'e.g. First Initial, Last Initial, Middle Initial',
    'limitHint': '1-3 letters',
    'spaces': false,
    'defaultText': 'wze',
    'allCaps': true,
    'specialChars': false,
  },
  'Ponce': {
    'charLimitRules': '1',
    'charMax': 1,
    'charMin': 1,
    'hint': 'e.g. First Initial or Last Initial',
    'limitHint': '1 letter',
    'spaces': false,
    'defaultText': 'w',
    'allCaps': true,
    'specialChars': false,
  }
}

export default EMBRULES